import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { SmallText } from '../../typography';
import { InvestmentsFilterSelectSC } from './investments-filter-select.styled';
import StateSelect from './components/state-select/state-select';

function InvestmentsFilterSelect({ onChange, value }) {
  return (
    <InvestmentsFilterSelectSC>
      <SmallText className="selector-text">
        <FormattedMessage
          id="table_filter_state_label"
          defaultMessage={dlt['table_filter_state_label']}
        />
      </SmallText>
      <StateSelect onChange={onChange} value={value} className="selector" />
    </InvestmentsFilterSelectSC>
  );
}

InvestmentsFilterSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default InvestmentsFilterSelect;
